import PropTypes from 'prop-types';
import Router from 'next/router';

import { NS } from '@/constants';
import { useAppDispatch } from '@/redux';
import { showLoginModal } from '@/redux/slices/gui.slice';
import { CallToActionKind } from '@/types';

import CallToActionContainer from '@/components/common/callToAction/CallToActionContainer';

import styles from './PrivateCellar.module.scss';
import { PAGES } from '@/constants/pages';
import { URLS } from '@/constants/urls';

export const PrivateCellar = ({ t }) => {
  const dispatch = useAppDispatch();

  return (
    <div className={styles.container} data-test-id="private-cellar" data-rbf="private-cellar">
      <img src={URLS.ICON_LOCK} alt="icon-lock" width={96} height={96} />
      <div>{t('restricted.privateCellar')}</div>
      <CallToActionContainer
        id="show-login"
        onClick={() => dispatch(showLoginModal())}
        fullWidth
      >
        {t('restricted.connectOrCreate')}
      </CallToActionContainer>
      <CallToActionContainer
        id="redirect-home"
        kind={CallToActionKind.TERTIARY}
        onClick={() => Router.push(PAGES.HOME)} fullWidth
      >
        {t('cart.resumeShopping', { ns: NS.CHECKOUT })}
      </CallToActionContainer>
    </div>
  );
};

PrivateCellar.propTypes = {
  t: PropTypes.func.isRequired
};

export default PrivateCellar;
